module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Arrow-to-left-ea2049621bdba1c8cd2385d17cca083f.svg";